<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2021-12-04 13:51:00
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-03-12 21:04:57
-->
<template>
  <el-form class="code" ref="codeForm" :model="form" :rules="rules">
    <el-form-item prop="phoneNum">
      <el-input
        v-model.number="form.phoneNum"
        placeholder="请输入手机号"
        type="text"
        tabindex="1"
        auto-complete="on"
        prefix-icon="el-icon-phone"
      />
    </el-form-item>
    <el-form-item prop="code">
      <el-input
        v-model.number="form.code"
        placeholder="请输入验证码"
        type="text"
        tabindex="1"
        auto-complete="on"
        prefix-icon="el-icon-s-promotion"
      >
        <el-button
          slot="append"
          class="code-btn"
          @click="onSendCode"
          :disabled="count > 0"
          >{{ count > 0 ? count + "秒后再获取" : "获取验证码" }}</el-button
        >
      </el-input>
    </el-form-item>
    <el-button
      :loading="loading"
      type="primary"
      style="width: 100%; margin-bottom: 30px"
      @click.native.prevent="validateCode"
      >登录</el-button
    >
  </el-form>
</template>

<script>
import HTTP_ACCOUNT from "@/api/account";
export default {
  name: "LoginByCode",
  data() {
    return {
      form: {
        phoneNum: "",
        code: "",
      },
      loading: false,
      count: 0, //倒计时
      rules: {
        phoneNum: [
          { required: true, trigger: "blur", message: "请输入" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入合法手机号",
            trigger: "blur",
          },
        ],
        code: [{ required: true, trigger: "blur", message: "请输入" }],
      },
    };
  },
  methods: {
    async validateCode() {
      this.$refs.codeForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            const res = await HTTP_ACCOUNT.checkMessage(this.form);
            if (res.code === 200) {
              const { data } = res;
              localStorage.setItem("op-token", data.token);
              localStorage.setItem("op-refresh-token", data.refreshToken);
              this.$message.success("登录成功");
              setTimeout(() => {
                this.$router.push({
                  path: "/",
                });
              }, 1000);
            } else {
              this.$message.error(
                typeof res.msg === "string" ? res.msg : "请求出错，请联系管理员"
              );
            }
          } finally {
            this.loading = false;
          }
        } else {
          return false;
        }
      });
    },
    async onLogin() {
      this.loading = true;
      try {
        const res = await HTTP_ACCOUNT.loginByCode(this.form);
        if (res.code === 200) {
          this.$router.push({
            name: "about",
          });
        } else {
          this.$message.error(
            typeof res.msg === "string" ? res.msg : "请求出错，请联系管理员"
          );
        }
      } catch (e) {
        this.$message.error("发生错误，请联系管理员");
      }
      this.loading = false;
    },
    async onSendCode() {
      if (this.form.phoneNum.length === 0) {
        this.$message.warning("请输入手机号");
        return;
      }
      const res = await HTTP_ACCOUNT.sendCode({
        phoneNum: this.form.phoneNum,
      });
      if (res.code === 200) {
        this.$message.success("验证码已成功发送");
        //60秒内不能发送
        this.count = 60;
        let timer = setInterval(() => {
          this.count--;
          if (this.count === 0) {
            clearInterval(timer);
          }
        }, 1000);
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.code {
  padding: 20px;
  .code-btn {
    background: rgba(#409eff, 0.8);
    color: white;
  }
}
</style>
